import { render } from "./AdminsCreate.vue?vue&type=template&id=4c47364c"
import script from "./AdminsCreate.vue?vue&type=script&lang=js"
export * from "./AdminsCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__